import React from 'react';
import { Tooltip } from '@material-ui/core';

const TruncatedText = ({ text, maxLength = 24, maxWidth = 200, style }) => {
  if (!text) return null;
  const content = (
    <span style={{ maxWidth, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block', verticalAlign: 'bottom', ...style }}>
      {text}
    </span>
  );
  return String(text).length > maxLength ? <Tooltip title={text} arrow>{content}</Tooltip> : content;
};

export default TruncatedText;
